module.exports = __webpack_public_path__ + "img/arhiva.868a3be0.png";